import React, { useEffect } from 'react'
import { Header } from '../components/layout/Header'
import { Footer } from '../components/layout/Footer'
import SEO from '../components/SEO'

const PrivacyPolicy: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="min-h-screen bg-white font-sans text-fg-2">
      <SEO 
        title="Privacy Policy | Jobloads" 
        description="Learn how Jobloads handles and protects your personal information."
        canonicalPath="/privacy"
      />
      <Header />
      
      <main className="max-w-[800px] mx-auto px-6 md:px-8 py-12 md:py-24">
        <h1 className="text-[clamp(36px,5vw,60px)] font-semibold leading-[1.02] tracking-[-0.03em] text-midnight-blue mb-8 md:mb-12">
          Privacy policy
        </h1>
        
        <div className="space-y-8 md:space-y-10 text-[19px] md:text-[21px] leading-[1.6] text-fg-3 font-subheading">
          <p>
            Last updated: 29 April 2026
          </p>
          
          <section className="space-y-4 md:space-y-6">
            <h2 className="text-[24px] md:text-[28px] font-semibold text-midnight-black font-sans tracking-tight">Introduction</h2>
            <p>
              Jobloads Limited ("we", "us", or "our") is committed to protecting your privacy. This policy explains how we handle your personal information in accordance with the New Zealand Privacy Act 2020.
            </p>
          </section>

          <section className="space-y-4 md:space-y-6">
            <h2 className="text-[24px] md:text-[28px] font-semibold text-midnight-black font-sans tracking-tight">Information we collect</h2>
            <p>
              We currently only collect your email address if you choose to sign up for our updates. We do not use cookies for tracking or collect any other personal identifiers on this landing page.
            </p>
          </section>

          <section className="space-y-4 md:space-y-6">
            <h2 className="text-[24px] md:text-[28px] font-semibold text-midnight-black font-sans tracking-tight">How we use your information</h2>
            <p>
              We use your email address solely to send you updates about Jobloads and the launch of Crewloads. We will not sell, rent, or lease your information to third parties.
            </p>
          </section>

          <section className="space-y-4 md:space-y-6">
            <h2 className="text-[24px] md:text-[28px] font-semibold text-midnight-black font-sans tracking-tight">Storage and security</h2>
            <p>
              We take reasonable steps to ensure your personal information is stored securely and protected from unauthorized access or use. Your data is stored on secure servers provided by our service providers.
            </p>
          </section>

          <section className="space-y-4 md:space-y-6">
            <h2 className="text-[24px] md:text-[28px] font-semibold text-midnight-black font-sans tracking-tight">Your rights</h2>
            <p>
              You have the right to access any personal information we hold about you and to ask for it to be corrected or deleted. You can also unsubscribe from our updates at any time by clicking the link in our emails or contacting us directly.
            </p>
          </section>

          <section className="space-y-4 md:space-y-6">
            <h2 className="text-[24px] md:text-[28px] font-semibold text-midnight-black font-sans tracking-tight">Contact us</h2>
            <p>
              If you have any questions about this policy or our privacy practices, please contact us at hello@jobloads.com.
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default PrivacyPolicy
